import { render, staticRenderFns } from "./AccessToRecords.vue?vue&type=template&id=f22aabd4&"
import script from "./AccessToRecords.vue?vue&type=script&lang=js&"
export * from "./AccessToRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f22aabd4')) {
      api.createRecord('f22aabd4', component.options)
    } else {
      api.reload('f22aabd4', component.options)
    }
    module.hot.accept("./AccessToRecords.vue?vue&type=template&id=f22aabd4&", function () {
      api.rerender('f22aabd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Privacy/AccessToRecords.vue"
export default component.exports